"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _coreListItem = _interopRequireDefault(require("@vfuk/core-list-item"));

var _coreDivider = _interopRequireDefault(require("@vfuk/core-divider"));

var Styled = _interopRequireWildcard(require("./styles/LinkList.style"));

var _TopLink = _interopRequireDefault(require("../TopLink"));

var _getDataAttributes = _interopRequireDefault(require("../../../../helpers/getDataAttributes"));

var _constants = require("../../../../constants");

var _TopNavigationContext = _interopRequireDefault(require("../../../../context/TopNavigationContext"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var LinkList = function LinkList(_ref) {
  var links = _ref.links;

  var _ref2 = (0, _react.useContext)(_TopNavigationContext["default"]),
      dataAttributePrefix = _ref2.dataAttributePrefix;

  return /*#__PURE__*/_react["default"].createElement(Styled.LinkList, {
    level: 1
  }, links.map(function (link, index) {
    return /*#__PURE__*/_react["default"].createElement(_coreListItem["default"], {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_TopLink["default"], {
      link: link,
      active: link.active
    }), !link.active && index !== links.length - 1 ? /*#__PURE__*/_react["default"].createElement(Styled.DividerWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreDivider["default"], {
      orientation: "vertical",
      appearance: "secondary",
      level: 1,
      inverse: true,
      noMargin: true
    })) : null, link.active && link.links ? /*#__PURE__*/_react["default"].createElement(Styled.LinkList, {
      level: 2
    }, link.links.map(function (secondaryLink, secondaryIndex) {
      return /*#__PURE__*/_react["default"].createElement(_coreListItem["default"], {
        key: secondaryIndex
      }, secondaryIndex === 0 ? /*#__PURE__*/_react["default"].createElement(Styled.DividerWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreDivider["default"], {
        orientation: "vertical",
        appearance: "secondary",
        level: 1,
        noMargin: true
      })) : null, /*#__PURE__*/_react["default"].createElement(Styled.SecondaryLink, {
        id: secondaryLink.id,
        href: secondaryLink.url,
        label: secondaryLink.srText,
        to: secondaryLink.to,
        onInteraction: secondaryLink.onClick,
        dataAttributes: _objectSpread(_objectSpread({}, secondaryLink.dataAttributes), {}, {
          'data-selector': (0, _getDataAttributes["default"])("".concat(_constants.DataKeys.TopBar, "-").concat(secondaryLink.id), dataAttributePrefix)
        })
      }, secondaryLink.text), secondaryIndex !== link.links.length - 1 ? /*#__PURE__*/_react["default"].createElement(Styled.DividerWrapper, null, /*#__PURE__*/_react["default"].createElement(_coreDivider["default"], {
        orientation: "vertical",
        appearance: "secondary",
        level: 1,
        noMargin: true
      })) : null);
    })) : null);
  }));
};

LinkList.displayName = "LinkList";
var _default = LinkList;
exports["default"] = _default;
//# sourceMappingURL=LinkList.js.map